import * as React from "react"

const NoImageIcon = ({...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#56aaff"
      d="M24 4H4a3 3 0 0 0-3 3v14a2.87 2.87 0 0 0 .28 1.25 1 1 0 0 0 .76.56h.14a1 1 0 0 0 .75-.34l7-7.93 3.87 4.83a1 1 0 0 0 1.43.13L19 16.32l3.34 2.86a1 1 0 0 0 1.05.16 3.94 3.94 0 0 1 2.4-.26 1 1 0 0 0 1.2-1V7A3 3 0 0 0 24 4Z"
    />
    <path
      fill="#0478ed"
      d="m23.64 17.66-4-3.42a1 1 0 0 0-1.3 0l-3.61 3.09-4-5A1 1 0 0 0 10 12a1 1 0 0 0-.77.34l-7.8 8.82a1 1 0 0 0-.16 1.07A3 3 0 0 0 4 24h16a1 1 0 0 0 1-1 4 4 0 0 1 1.17-2.83 3.89 3.89 0 0 1 1.22-.83 1 1 0 0 0 .26-1.68Z"
    />
    <path
      fill="#fff"
      d="M28.54 26.54a5 5 0 0 1-7.08-7.08 4.89 4.89 0 0 1 1.53-1 5 5 0 0 1 5.55 1 5 5 0 0 1 0 7.08Z"
    />
    <path
      fill="#56aaff"
      d="M25 29a6 6 0 0 1-4.25-10.24 6 6 0 0 1 8.49 0 6 6 0 0 1 0 8.49A6 6 0 0 1 25 29Zm0-10a4 4 0 0 0-2.82 1.17 4 4 0 0 0 0 5.67 4 4 0 1 0 5.66-5.67 3.9 3.9 0 0 0-2-1.08A4 4 0 0 0 25 19Zm3.55 7.54Z"
    />
    <path
      fill="#56aaff"
      d="M21.46 27.54a1 1 0 0 1-.71-1.71l7.07-7.07a1 1 0 0 1 1.41 1.41l-7.07 7.07a1 1 0 0 1-.7.3Z"
    />
    <circle cx={16} cy={10} r={2} fill="#fff" />
  </svg>
)

export default NoImageIcon